import gql from 'graphql-tag';

export default gql`
subscription {
    onUpdateEtlPackageExecution {
        __typename
        id
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlPackageExecutions/UpdateSubscription.js